let cachedResult;

export function hasWebpSupport() {
  if (cachedResult !== undefined) {
    return cachedResult;
  }

  try {
    const canvas = document.createElement('canvas');
    cachedResult = canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  } catch {
    cachedResult = false;
  }

  return cachedResult;
}